/*eslint-env node*/

"use strict";
var _ = require("underscore");
var Module = function(args) {

    // Merge arguments object in the Module loader. Expected values:
    // this.name
    // this.htmlTemplate
    // this.callback

    if (args) {
        for (var attrname in args) {
            if (args.hasOwnProperty(attrname)) {
                this[attrname] = args[attrname];
            }
        }
    }

    this.render = function(template, data) {
        var template = template ? _.template(template) : _.template(this.htmlTemplate),
            renderedTemplate = template(Object.assign({
                module: this
            }, data));
        return renderedTemplate;
    };

    this.inject = function (renderedTemplate) {
        const container = document.getElementById(this.id);
        // Append rendered module in the container element in the DOM
        container.appendChild(renderedTemplate);
    };

    this.init = function(data, id) {

        if (id) {
            this.id = id;
        }

        this.templateData = Object.assign({
            module: this
        }, data);

        // Render module
        var renderedTemplate = this.render(this.htmlTemplate, this.templateData);

        this.inject(renderedTemplate);

        // Execute any module specific javascript
        if (_.isFunction(this.callback)) {
            this.callback();
        }
    };
};

module.exports = Module;



// WEBPACK FOOTER //
// ./common/module-loader.js